module.exports = __webpack_public_path__ + "media/common/images/badges/gray/elektrizujici_vykon-4a62839548ea6568590f4713e55a4aca.svg";